import React, { useEffect } from 'react';
import { ArrowRight, BadgeCheck, Gauge, Headphones, LockKeyhole, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import OfferGrid from '../components/OfferGrid';
import PageMeta from '../components/PageMeta';
import { useLanguage } from '../i18n/LanguageProvider';
import teamImage from '../assets/1.webp';

const About = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const commitments = [
    { icon: LockKeyhole, label: 'Sécurité' },
    { icon: Gauge, label: 'Fiabilité' },
    { icon: ShieldCheck, label: 'Conformité' },
    { icon: Headphones, label: 'Accompagnement technique' },
  ];

  return (
    <div className="ws-page ws-about" data-no-i18n="true">
      <PageMeta
        title="À propos de WonyaSoft"
        description="WonyaSoft est une entreprise technologique congolaise spécialisée dans les paiements numériques, les logiciels et les solutions monétiques."
      />

      <section className="ws-page-hero ws-page-hero--about">
        <div className="ws-shell ws-page-hero__content">
          <span className="ws-eyebrow"><BadgeCheck size={18} aria-hidden="true" /> {t('À propos de WonyaSoft')}</span>
          <h1>{t('La technologie congolaise au service des paiements')}</h1>
          <p>{t('WonyaSoft est une entreprise technologique congolaise spécialisée dans le développement de solutions numériques de paiement, l’édition de logiciels et la conception de plateformes monétiques adaptées aux réalités du marché congolais.')}</p>
        </div>
      </section>

      <section className="ws-section">
        <div className="ws-shell ws-about-story">
          <div className="ws-about-story__image">
            <img src={teamImage} alt={t('Équipe WonyaSoft au travail')} loading="lazy" />
            <span><BadgeCheck size={18} aria-hidden="true" /> {t('Agrément Banque Centrale du Congo')}</span>
          </div>
          <div className="ws-about-story__copy">
            <span className="ws-kicker">{t('Qui sommes-nous ?')}</span>
            <h2>{t('À propos de WonyaSoft')}</h2>
            <p>{t('WonyaSoft accompagne les entreprises, institutions, établissements scolaires, marchands et développeurs dans leur transformation numérique. À travers sa plateforme WonyaPay, l’entreprise facilite l’intégration des paiements Mobile Money, les paiements en masse, l’encaissement mobile et le développement de solutions de paiement sur mesure.')}</p>
            <div className="ws-approval-note">
              <ShieldCheck size={24} aria-hidden="true" />
              <p>{t('WonyaSoft est agréée par la Banque Centrale du Congo en qualité d’agrégateur, d’éditeur de logiciels et de fournisseur de solutions monétiques.')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="ws-section ws-section--soft">
        <div className="ws-shell ws-mission-card">
          <span className="ws-kicker">{t('Notre mission')}</span>
          <h2>{t('Notre mission est de rendre les paiements numériques plus simples, accessibles, sécurisés et adaptés aux besoins des organisations congolaises.')}</h2>
        </div>
      </section>

      <section className="ws-section" aria-labelledby="ws-about-offers-title">
        <div className="ws-shell">
          <div className="ws-section-heading">
            <span className="ws-kicker">{t('Nos principales solutions')}</span>
            <h2 id="ws-about-offers-title">{t('Un écosystème, trois façons d’avancer')}</h2>
          </div>
          <OfferGrid />
        </div>
      </section>

      <section className="ws-section ws-section--dark">
        <div className="ws-shell ws-commitment">
          <div className="ws-commitment__copy">
            <span className="ws-kicker">{t('Notre engagement')}</span>
            <h2>{t('Un cadre de confiance pour vos paiements')}</h2>
            <p>{t('Nous accordons une importance particulière à la sécurité, à la fiabilité, à la conformité, à la disponibilité des services et à la qualité de l’accompagnement technique fourni à nos partenaires.')}</p>
          </div>
          <div className="ws-commitment__grid">
            {commitments.map(({ icon: Icon, label }) => (
              <div key={label}><Icon size={22} aria-hidden="true" /><span>{t(label)}</span></div>
            ))}
          </div>
        </div>
      </section>

      <section className="ws-section">
        <div className="ws-shell ws-final-cta">
          <div>
            <span className="ws-kicker">WonyaSoft</span>
            <h2>{t('Construisons votre prochaine solution de paiement')}</h2>
            <p>{t('Notre équipe vous accompagne depuis l’analyse de votre besoin jusqu’à l’intégration et la mise en production.')}</p>
          </div>
          <div className="ws-button-row">
            <Link className="ws-button ws-button--primary" to="/contact">{t('Nous contacter')} <ArrowRight size={18} aria-hidden="true" /></Link>
            <Link className="ws-button ws-button--secondary" to="/appmobile">{t('Découvrir WonyaPay')}</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
